const ServicesGrid = () => {
  const services = [
    {
      icon: 'ri-truck-line',
      title: 'Full Truckload (FTL)',
      description: 'Dedicated full truckload services for large shipments requiring exclusive use of a trailer. Perfect for businesses with high-volume freight needs.',
      features: [
        'Exclusive trailer use',
        'Direct point-to-point delivery',
        'Faster transit times',
        'Enhanced security for valuable cargo',
      ],
    },
    {
      icon: 'ri-box-3-line',
      title: 'Less Than Truckload (LTL)',
      description: 'Cost-effective shipping solutions for smaller freight volumes. Share trailer space with other shipments and pay only for the space you use.',
      features: [
        'Flexible volume options',
        'Competitive pricing',
        'Regular scheduled routes',
        'Professional handling and care',
      ],
    },
    {
      icon: 'ri-time-line',
      title: 'Expedited Shipping',
      description: 'Time-critical delivery services for urgent shipments. Our expedited solutions ensure your freight arrives exactly when you need it.',
      features: [
        'Same-day and next-day options',
        'Priority handling',
        'Real-time tracking',
        'Dedicated dispatch support',
      ],
    },
    {
      icon: 'ri-map-pin-line',
      title: 'Regional Distribution',
      description: 'Strategic regional coverage across the Midwest with optimized routes and local expertise for efficient distribution.',
      features: [
        'Midwest coverage excellence',
        'Optimized delivery routes',
        'Local market knowledge',
        'Flexible scheduling options',
      ],
    },
    {
      icon: 'ri-temperature-line',
      title: 'Temperature Controlled',
      description: 'Specialized refrigerated and climate-controlled transportation for temperature-sensitive goods and perishables.',
      features: [
        'Refrigerated trailers',
        'Temperature monitoring',
        'Food-grade certified',
        'Compliance with regulations',
      ],
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Specialized Freight',
      description: 'Expert handling of oversized, heavy, or specialized cargo requiring unique equipment and expertise.',
      features: [
        'Oversized load permits',
        'Specialized equipment',
        'Expert route planning',
        'Safety compliance',
      ],
    },
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white rounded-3xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 border border-[#FFE5D4] group cursor-pointer"
            >
              <div className="w-16 h-16 bg-gradient-to-br from-[#FF8C42] to-[#D4693A] rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className={`${service.icon} text-3xl text-white`}></i>
              </div>
              
              <h3 className="text-2xl font-bold text-[#2A2A2A] mb-4">
                {service.title}
              </h3>
              
              <p className="text-[#6B6B6B] leading-relaxed mb-6">
                {service.description}
              </p>
              
              <ul className="space-y-3">
                {service.features.map((feature, idx) => (
                  <li key={idx} className="flex items-start text-sm">
                    <i className="ri-check-line text-[#FF8C42] text-lg mr-2 mt-0.5"></i>
                    <span className="text-[#2A2A2A]">{feature}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesGrid;